import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_DATA_ASYNC = createAsyncTypes(
  'FETCH_DATA_ASYNC',
  'ResolutionCenter/AccountInvestigation'
)

export const FETCH_DEPARTMENTS_ASYNC = createAsyncTypes(
  'FETCH_DEPARTMENTS_ASYNC',
  'ResolutionCenter/AccountInvestigation'
)

export const SET_PAGE_NUMBER = 'ResolutionCenter/AccountInvestigation/SET_PAGE_NUMBER'
export const SET_ARRIVAL_DATE = 'ResolutionCenter/AccountInvestigation/SET_ARRIVAL_DATE'
export const SET_DEPARTMENT = 'ResolutionCenter/AccountInvestigation/SET_DEPARTMENT'
export const SET_EMAIL_ADDRESS = 'ResolutionCenter/AccountInvestigation/SET_EMAIL_ADDRESS'
export const RESET_ALL_FILTERS = 'ResolutionCenter/AccountInvestigation/RESET_ALL_FILTERS'

export const LICENSE_DATA_REQUEST_ASYNC = createAsyncTypes(
  'LICENSE_DATA_REQUEST_REQUEST',
  'ResolutionCenter/AccountInvestigation'
)

export const TOGGLE_ADDON_TO_UNLOCK = 'ResolutionCenter/AccountInvestigation/TOGGLE_ADDON_TO_UNLOCK'
export const RESET_SELECTED_ADDONS = 'ResolutionCenter/AccountInvestigation/RESET_SELECTED_ADDONS'

export const CREATE_ATO_INCIDENT_ASYNC = createAsyncTypes(
  'CREATE_ATO_INCIDENT_ASYNC',
  'ResolutionCenter/AccountInvestigation'
)
export const SET_ALERT_ID = 'ResolutionCenter/AccountInvestigation/SET_ALERT_ID'
